import type { QueryFunctionContext } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { requestWithAuth } from '@/utilities/graphQLClient';
import { NOTE_FRAGMENT } from './note-fragment';
import type { NoteFragmentType } from './note-fragment';

export interface QueryResponse {
  errors?: Error[];
  Notes: NoteFragmentType[];
}

type QueryContext = QueryFunctionContext<[string, string | undefined]>;

export const queryFn = async (
  { queryKey: [_, userId] }: QueryContext,
  limit = 5
) => {
  if (typeof userId === 'undefined') {
    return Promise.reject(new Error('User ID must be provided'));
  }
  const { Notes, errors } = await requestWithAuth<QueryResponse>(
    gql`
      query getUserNotes($limit: Float) {
        Notes(size: $limit) {
          ...NoteFields
        }
      }
      ${NOTE_FRAGMENT}
    `,
    { limit }
  );

  if (errors?.length) {
    const [firstError] = errors;
    throw new Error(firstError.message);
  }

  return Notes ?? [];
};
